export class ContactChatApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns CreateChatResult
     * @throws ApiError
     */
    createChatForContact({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contact-chat',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
